require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-awesome-job-event-preview.json") })
        }
      }, "path---blog-awesome-job-event-preview");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-awesome-job-event-preview!./.cache/json/blog-awesome-job-event-preview.json
// module id = 711
// module chunks = 231608221292675